module.exports = __webpack_public_path__ + "img/vehicle-slides-backdrop-toyota.4e2bab9d.png";